let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f0T6G")).then(() => parcelRequire('4MGQJ'));